import { useEventCallback } from '../hooks/useEventCallback';
import { getEventPayload } from './utilsImpactRadius';
import type { ImpactRadiusEventType } from './impactRadius.types';
import { useTrackImpactRadiusMutation } from '@graphql/generated';
import { getEventTypeConfig } from '@config';
import { useEventInfo } from '../eventInfo';
import { useAuth } from '@shared/components/AuthProvider';

export function useTrackImpactRadius() {
  const [trackImpactRadiusMutation] = useTrackImpactRadiusMutation();
  const { eventInfo } = useEventInfo();
  const { currentUser } = useAuth();

  const trackImpactRadius = useEventCallback((impactRadiusEventType: ImpactRadiusEventType) => {
    const eventId = eventInfo?.eventId;
    const eventType = eventInfo?.eventType;
    if (eventId && eventType) {
      const eventTypeConfig = getEventTypeConfig(eventType);
      const payload = getEventPayload(
        eventTypeConfig.impactRadiusCampaignId,
        eventTypeConfig.impactRadiusActionTrackerId,
        impactRadiusEventType,
        eventId,
        currentUser.profile?.activeAlias?.auth0Id,
      );
      if (payload) {
        trackImpactRadiusMutation({
          variables: {
            payload,
          },
        });
      }
    }
  });

  return trackImpactRadius;
}
